import React from 'react';

import SupervisorDetalle from 'components/Tvendo/Sale/QuotaBPartner/CuotasIncentivos/Unilever/Supervisor/SupervisorDetalle/List.js';

export default function () {
  return <SupervisorDetalle />;
}
